<template>
  <footer class="footer">
    <div class="footer__elements-container">
      <div class="footer__company-element">
        &copy;&nbsp;Steinm&uuml;ller&nbsp;Group
      </div>
      <div class="footer__link-list">
        <div v-if="!Config.isCompass" class="footer__link-element">
          <a
            :href="getHomepageLink(HomepageSubPage.IMPRINT)"
            target="_blank"
            data-test="footer-link-imprint"
            >{{ $t("footer.imprint") }}</a
          >
        </div>
        <div v-if="!Config.isCompass" class="footer__link-element">
          <router-link
            :to="{ name: RouteNames.PRIVACY_POLICY }"
            data-test="footer-link-privacy"
          >
            {{ $t("footer.privacy") }}
          </router-link>
        </div>
        <div v-if="!Config.isCompass" class="footer__link-element">
          <router-link
            :to="{ name: RouteNames.TERMS_OF_USE }"
            data-test="footer-link-tos"
          >
            {{ $t("footer.tos") }}
          </router-link>
        </div>
        <div v-if="!Config.isCompass" class="footer__link-element">
          <a :href="swaggerAPILink" target="_blank" data-test="footer-link-api">
            API
          </a>
        </div>
        <div class="footer__link-element">
          <a
            :href="
              Config.isCompass
                ? mailToLink
                : getHomepageLink(HomepageSubPage.CONTACT)
            "
            target="_blank"
            data-test="footer-link-contact"
            >{{ $t("footer.contact") }}</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { HomepageSubPage, useHomepageLink } from "@/composables/homepageLink";
import { RouteNames } from "@/router";
import Config from "@/common/config";
import { computed } from "vue";

const { getHomepageLink } = useHomepageLink();

const swaggerAPILink = computed(() => {
  const baseURL = Config.apiEndpoints.baseURL.includes("localhost")
    ? "https://et-test.egetrans.com/"
    : Config.apiEndpoints.baseURL;

  return `${baseURL}api/v1`;
});

const mailToLink = computed(() => {
  const recipient = "it-support@egetrans.com";
  return encodeURI(`mailTo:${recipient}?subject=Contact form ET Compass`);
});
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  height: 100%;

  background-color: $color-etBlue;
  color: white;
}

.footer__elements-container {
  max-width: $layout-max-content-width;
  height: 100%;

  margin: 0 auto;

  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: $breakpoint-content-width) {
    margin: 0 $layout-min-horizontal-margin;
  }
}

.footer__link-list {
  display: flex;
  flex-flow: row nowrap;
  gap: 60px;

  @media screen and (max-width: $breakpoint-medium) {
    gap: 32px;
  }
}

.footer__company-element {
  gap: 200px;
  justify-self: left;
}

.footer__link-element a {
  color: white;
  font-weight: bold;
}

@media screen and (max-width: $breakpoint-small) {
  .footer {
    padding-top: 24px;
    padding-bottom: 8px;
  }

  .footer__elements-container {
    flex-direction: column-reverse;

    gap: 24px;
  }

  .footer__link-list {
    flex-direction: column;

    align-items: center;

    gap: 10px;
  }
}
</style>
